import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "../../lib/attribution";
import {
  createEngagementTimer,
  installClickTracking,
  installScrollTracking,
  track,
  trackPageView,
} from "../../lib/analytics";

// Nem renderel semmit – csak a globális eseményfigyelőket köti be.
export default function AnalyticsTracker() {
  const { pathname, search } = useLocation();

  const scroll = useRef(null);
  const timer = useRef(null);
  const currentPage = useRef(null);
  const flush = useRef(() => {});

  useEffect(() => {
    // Az erkezesi forrast az elso betoltesnel kell elkapni, mielott a
    // route-valtasok elmosnak az URL-t
    captureAttribution();

    const uninstallClicks = installClickTracking();
    scroll.current = installScrollTracking();
    timer.current = createEngagementTimer();

    // az aktuális oldalon eltöltött aktív idő kiküldése
    flush.current = () => {
      if (!timer.current || !currentPage.current) return;
      const seconds = Math.round(timer.current.elapsed() / 1000);
      timer.current.reset();
      if (seconds < 1) return;
      track("page_engagement", {
        page_path: currentPage.current,
        engagement_time_sec: seconds,
      });
    };

    const onPageHide = () => flush.current();
    window.addEventListener("pagehide", onPageHide);

    return () => {
      flush.current();
      window.removeEventListener("pagehide", onPageHide);
      uninstallClicks();
      if (scroll.current) scroll.current.uninstall();
      if (timer.current) timer.current.uninstall();
    };
  }, []);

  useEffect(() => {
    const path = pathname + (search || "");
    if (currentPage.current === path) return;

    // az előző oldal idejét még lezárjuk
    flush.current();

    currentPage.current = path;
    if (scroll.current) scroll.current.reset();
    trackPageView(path);
  }, [pathname, search]);

  return null;
}
